import { render, staticRenderFns } from "./serviceAlert.vue?vue&type=template&id=7256f460&scoped=true"
import script from "./serviceAlert.vue?vue&type=script&lang=js"
export * from "./serviceAlert.vue?vue&type=script&lang=js"
import style0 from "./serviceAlert.vue?vue&type=style&index=0&id=7256f460&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7256f460",
  null
  
)

export default component.exports